const debug = require('debug')

export default {
  install(Vue) {
    Vue.prototype.$debug = function() {
      const scope = this.$options.debug || this.$options.name || 'default'
      return debug('app:' + scope)(...arguments)
    }

    Vue.debug = debug('app:default')
    window.$debug = Vue.debug
  }
}
